module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_indices.b103d0a4.tom";